import axios from "axios";
import { toast } from "react-toastify";

const listRcs = async (filters = {}) => {
  const bearerToken = localStorage.getItem("cu_user");
  try {
    const { data } = await axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_HOST}/api/rc`,
      params: filters,
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    });
    return data.data;
  } catch (error) {
    return [];
  }
};

const addFarmer = async (values, setIsloading) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/farmer`;

  // const finalValues = {
  //   firstName: "Naveen",
  //   lastName: "CU",
  //   gender: "Male",
  //   dob: "12/12/1980",
  //   ginnerIds: "G0001",
  //   idProof: "012345678900",
  //   education: "digree",
  //   address: {
  //     location: {
  //       type: "Point",
  //       coordinates: {
  //         longitude: "12.4",
  //         latitude: "45.4",
  //       },
  //     },
  //     district: "Nagpur",
  //     state: "Maharashtra",
  //     country: "India",
  //     pinCode: "151412",
  //     raw_address: "Shelton Sapphaire, Belapur",
  //   },
  // };

  return toast.promise(
    new Promise(async (resolve, reject) => {
      const token = localStorage.getItem("cu_user");
      let response = await axios.post(url, values, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      try {
        if (response.data.status === "success") {
          resolve(response);

          setIsloading(false);
          return response?.data;
        } else {
          reject(response.data.status);
        }
      } catch (error) {
        reject(error);
        setIsloading(false);
        console.error(error);
      }
    }),
    {
      pending: "Adding Farmer...",
      success: "Added farmer successfully",
      error: "Error adding farmer",
    }
  );
};

const updateFarmer = async (values, id) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/farmer/${id}`;
  const token = localStorage.getItem("cu_user");
  let response = await axios.patch(url, values, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  try {
    if (response.data.status === "success") {
      return response?.data;
    } else {
      console.log(response);
    }
  } catch (error) {
    console.error(error);
  }
};

const updateExternalSupplier = async (values, id) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/external-supplier/${id}`;
  const token = localStorage.getItem("cu_user");
  let response = await axios.patch(url, values, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  try {
    if (response.data.status === "success") {
      return response?.data;
    } else {
      console.log(response);
    }
  } catch (error) {
    console.error(error);
  }
};

const updateProcurement = async (id, values) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/procurement/${id}`;
  const token = localStorage.getItem("cu_user");
  let response = await axios.patch(url, values, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  try {
    if (response.data.status === "success") {
      console.log(response);
      return response?.data;
    } else {
      console.log(response);
    }
  } catch (error) {
    console.error(error);
  }
};

const deleteFarmer = async (id) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/farmer/${id}`;
  const token = localStorage.getItem("cu_user");
  let response = await axios.delete(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  try {
    if (response.data.status === "success") {
      return response?.data;
    } else {
      console.log(response);
    }
  } catch (error) {
    console.error(error);
  }
};

const applyForm = async (values, resetForm, setIsloading) => {
  setIsloading(true);
  const url = `${process.env.REACT_APP_API_HOST}/api/cui-application-form`;

  return toast.promise(
    new Promise(async (resolve, reject) => {
      try {
        let response = await axios.post(url, values);
        if (response.data.status === "success") {
          resolve(response);

          resetForm();
          setIsloading(false);
          return response?.data;
        } else {
          reject(response.data.status);
        }
      } catch (error) {
        reject(error);
        setIsloading(false);
        console.error(error);
      }
    }),
    {
      pending: "Registering...",
      success: "Application registered successfully",
      error: "Error registering application",
    }
  );
};

const applyTcForm = async (values, resetForm, setIsLoading) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/tc`;

  return toast.promise(
    new Promise(async (resolve, reject) => {
      const token = localStorage.getItem("cu_user");
      try {
        let response = await axios.post(url, values, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.data.status === "success") {
          resolve(response);

          resetForm();
          setIsLoading(false);
          return response?.data;
        } else {
          reject(response.data.status);
        }
      } catch (error) {
        reject(error);
        setIsLoading(false);
        console.error(error);
      }
    }),
    {
      pending: "Applying...",
      success: "Application registered successfully",
      error: "Error registering application",
    }
  );
};

const updateTcForm = async (values, id) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/tc/update/v2/${id}`;

  return toast.promise(
    new Promise(async (resolve, reject) => {
      const token = localStorage.getItem("cu_user");
      try {
        let response = await axios.patch(url, values, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.data.status === true) {
          resolve(response);

          return response?.data;
        } else {
          reject(response.data.status);
        }
      } catch (error) {
        reject(error);
        console.error(error);
      }
    }),
    {
      pending: "updating...",
      success: "Application updated successfully",
      error: "Error updating application",
    }
  );
};

const signIn = async (values, setIsloading) => {
  setIsloading(true);
  const url = `${process.env.REACT_APP_API_HOST}/api/user/signIn`;

  return toast.promise(
    new Promise(async (resolve, reject) => {
      try {
        let response = await axios.post(url, values);
        if (response.data.status === "success") {
          setIsloading(false);
          resolve(response?.data);
        } else {
          setIsloading(false);
          reject(response?.data?.message);
        }
      } catch (error) {
        setIsloading(false);
        reject(error.response.data);
      }
    }),
    {
      pending: "Signing In...",
      success: "User verified successfully",
      error: {
        render({ data }) {
          return `${data?.message}`;
        },
      },
    }
  );
};

const sendOTP = async (email, setIsloading) => {
  setIsloading(true);
  const url = `${process.env.REACT_APP_API_HOST}/api/user/resend-otp`;

  const finalObj = {
    email: email,
  };

  return toast.promise(
    new Promise(async (resolve, reject) => {
      try {
        let response = await axios.patch(url, finalObj);
        if (response.data.status === "success") {
          setIsloading(false);
          resolve(response?.data);
        } else {
          setIsloading(false);
          reject(response?.data?.message);
        }
      } catch (error) {
        setIsloading(false);
        reject(error.response.data);
      }
    }),
    {
      pending: "Sending...",
      success: "OTP send successfully",
      error: {
        render({ data }) {
          return `${data?.message}`;
        },
      },
    }
  );
};

const fogotPassword = async (email, resetForm, setIsloading) => {
  setIsloading(true);
  const url = `${process.env.REACT_APP_API_HOST}/api/user/forget-password`;

  return toast.promise(
    new Promise(async (resolve, reject) => {
      try {
        let response = await axios.patch(url, email);
        if (response.data.status === "success") {
          setIsloading(false);
          resetForm();
          resolve(response?.data);
        } else {
          setIsloading(false);
          resetForm();
          reject(response?.data?.message);
        }
      } catch (error) {
        setIsloading(false);
        reject(error.response.data);
      }
    }),
    {
      pending: "Sending Email...",
      success: "Email send successfully",
      error: {
        render({ data }) {
          return `${data?.message}`;
        },
      },
    }
  );
};

const resetPassword = async (values, id, setIsloading) => {
  setIsloading(true);
  const url = `${process.env.REACT_APP_API_HOST}/api/user/reset-password/${id}`;

  return toast.promise(
    new Promise(async (resolve, reject) => {
      try {
        let response = await axios.patch(url, values);
        if (response.data.status === "success") {
          setIsloading(false);
          resolve(response?.data);
        } else {
          setIsloading(false);
          reject(response?.data?.message);
        }
      } catch (error) {
        setIsloading(false);
        reject(error.response.data);
      }
    }),
    {
      pending: "Resetting...",
      success: "Password Resetted Successfully",
      error: {
        render({ data }) {
          return `${data?.message}`;
        },
      },
    }
  );
};

const addFarm = async (values, resetForm) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/farm`;
  const token = localStorage.getItem("cu_user");
  let response = await axios.post(url, values, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  try {
    if (response.data.status === "success") {
      resetForm();
      return response?.data;
    } else {
      console.log("");
    }
  } catch (error) {
    console.error(error);
  }
};

const updateFarm = async (values, id) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/farm/${id}`;
  const token = localStorage.getItem("cu_user");
  let response = await axios.patch(url, values, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  try {
    if (response.data.status === "success") {
      return response?.data;
    } else {
      console.log(response);
    }
  } catch (error) {
    console.error(error);
  }
};

const deleteFarm = async (id) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/farm/${id}`;
  const token = localStorage.getItem("cu_user");
  let response = await axios.delete(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  try {
    if (response.data.status === "success") {
      return response?.data;
    } else {
      console.log(response);
    }
  } catch (error) {
    console.error(error);
  }
};

const getFarmers = async () => {
  const url = `${process.env.REACT_APP_API_HOST}/api/farmer`;
  const token = localStorage.getItem("cu_user");
  let response = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  try {
    if (response.data.status === "success") {
      return response?.data;
    } else {
      console.log("");
    }
  } catch (error) {
    console.error(error);
  }
};

const getUsers = async () => {
  const url = `${process.env.REACT_APP_API_HOST}/api/user`;
  const token = localStorage.getItem("cu_user");
  let response = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  try {
    if (response.data.status === "success") {
      return response?.data;
    } else {
      console.log("");
    }
  } catch (error) {
    console.error(error);
  }
};

const getFarmer = async (farmerId) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/farmer/${farmerId}`;
  const token = localStorage.getItem("cu_user");
  let response = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  try {
    if (response.data.status === "success") {
      return response?.data;
    } else {
      console.log("");
    }
  } catch (error) {
    console.error(error);
  }
};

const getProcByProcId = async (procId) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/procurement/${procId}`;
  const token = localStorage.getItem("cu_user");
  let response = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  try {
    if (response.data.status === "success") {
      return response?.data;
    } else {
      console.log("");
    }
  } catch (error) {
    console.error(error);
  }
};

const getProcess = async () => {
  const url = `${process.env.REACT_APP_API_HOST}/api/process`;

  let response = await axios.get(url);
  try {
    if (response.data.status === "success") {
      return response?.data;
    } else {
      console.log("");
    }
  } catch (error) {
    console.error(error);
  }
};

const getProgram = async () => {
  const url = `${process.env.REACT_APP_API_HOST}/api/program`;

  let response = await axios.get(url);
  try {
    if (response.data.status === "success") {
      return response?.data;
    } else {
      console.log("");
    }
  } catch (error) {
    console.error(error);
  }
};

const getSingleProgram = async (id) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/program/${id}`;

  let response = await axios.get(url);
  try {
    if (response.data.status === "success") {
      return response?.data;
    } else {
      console.log("");
    }
  } catch (error) {
    console.error(error);
  }
};

const checkResetPage = async (id) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/user/check-token/${id}`;

  let response = await axios.get(url);
  try {
    if (response.data.status === "success") {
      return response?.data;
    } else {
      console.log("");
    }
  } catch (error) {
    console.error(error);
  }
};

const getCommodity = async () => {
  const url = `${process.env.REACT_APP_API_HOST}/api/commodity`;

  let response = await axios.get(url);
  try {
    if (response.data.status === "success") {
      return response?.data;
    } else {
      console.log("");
    }
  } catch (error) {
    console.error(error);
  }
};

const addProcurementForm = async (values, setIsloading) => {
  return toast.promise(
    new Promise(async (resolve, reject) => {
      const token = localStorage.getItem("cu_user");
      try {
        let res = await axios.post(
          `${process.env.REACT_APP_API_HOST}/api/procurement`,
          values,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (res?.data?.status === "success") {
          resolve(res);
          setIsloading(false);
          return res?.data;
        }
      } catch (error) {
        reject(error?.response?.data);
        setIsloading(false);
      }
    }),
    {
      pending: "Adding...",
      success: "Procurement sent for admin approval",
      error: {
        render({ data }) {
          return `${data?.message}`;
        },
      },
    }
  );
};

const getCompanyData = async (id) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/company/${id}`;
  try {
    const token = localStorage.getItem("cu_user");
    let response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.data.status === "success") {
      return response?.data;
    } else {
      console.log("");
    }
  } catch (error) {
    console.error(error);
  }
};

const getCompanyUnit = async (id) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/company-unit/${id}`;
  try {
    const token = localStorage.getItem("cu_user");
    let response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.data.status === "success") {
      return response?.data;
    } else {
      console.log("");
    }
  } catch (error) {
    console.error(error);
  }
};

const getAllExternalSuppliers = async () => {
  const url = `${process.env.REACT_APP_API_HOST}/api/external-supplier`;
  try {
    const token = localStorage.getItem("cu_user");
    let response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.data.status === "success") {
      return response?.data;
    } else {
      console.log("");
    }
  } catch (error) {
    console.error(error);
  }
};

const getAllHeaps = async () => {
  const url = `${process.env.REACT_APP_API_HOST}/api/heap`;
  try {
    const token = localStorage.getItem("cu_user");
    let response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.data.status === "success") {
      return response?.data;
    } else {
      console.log("");
    }
  } catch (error) {
    console.error(error);
  }
};

const getProductInfo = async (id) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/product/${id}`;
  try {
    const token = localStorage.getItem("cu_user");
    if (id) {
      let response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data.status === "success") {
        return response?.data;
      } else {
        console.log("");
      }
    }
  } catch (error) {
    console.error(error);
  }
};

const getInventory = async (id) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/inventory?companyId=${id}`;
  try {
    const token = localStorage.getItem("cu_user");
    let response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.data.status === "success") {
      return response?.data;
    } else {
      console.log("");
    }
  } catch (error) {
    console.error(error);
  }
};

const getSellerUnits = async () => {
  const url = `${process.env.REACT_APP_API_HOST}/api/company-unit`;
  try {
    const token = localStorage.getItem("cu_user");
    let response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.data.status === "success") {
      return response?.data;
    } else {
      console.log("");
    }
  } catch (error) {
    console.error(error);
  }
};

const getAllBrokers = async (type) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/external-supplier?type=${type}`;
  try {
    const token = localStorage.getItem("cu_user");
    let response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response?.data;
  } catch (err) {
    return err?.response?.data;
  }
};

const getOneSupplier = async (id) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/external-supplier/${id}`;
  try {
    const token = localStorage.getItem("cu_user");
    let response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response?.data;
  } catch (err) {
    return err?.response?.data;
  }
};

const getOneInventoryDetails = async (id) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/inventory/${id}`;
  try {
    const token = localStorage.getItem("cu_user");
    let response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response?.data;
  } catch (err) {
    return err?.response?.data;
  }
};

const getGeoCodes = async (address) => {
  // Check if the address is a sentence with at least two words that have at least 3 characters each
  const regex = /\b[a-zA-Z]{3,}\b.*\b[a-zA-Z]{3,}\b/;
  if (regex.test(address)) {
    const url = `${process.env.REACT_APP_API_HOST}/api/address/getGeocodes`;
    const finalObj = {
      address: address,
    };
    try {
      const token = localStorage.getItem("cu_user");
      let response = await axios.post(url, finalObj, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data.status === "success") {
        return response?.data;
      } else {
        console.log("");
      }
    } catch (error) {
      console.error(error);
    }
  }
};

const getSuggestions = async (address) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/address/getSuggestions`;
  const finalObj = {
    address: address,
  };
  try {
    const token = localStorage.getItem("cu_user");
    let response = await axios.post(url, finalObj, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.data.status === "success") {
      return response?.data;
    } else {
      console.log("");
    }
  } catch (error) {
    console.error(error);
  }
};

const getInventoryProc = async (id, unitId, input = false, heapIdsToRemove) => {
  let additionalURLToRemoveHeadId = "";
  heapIdsToRemove?.forEach((id) => {
    additionalURLToRemoveHeadId += `&heapId[$nin]=${id}`;
  });
  let url = `${process.env.REACT_APP_API_HOST}/api/inventory/list/tc-proc/${id}?input=${input}${additionalURLToRemoveHeadId}`;

  try {
    const token = localStorage.getItem("cu_user");
    let response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.data.status === "success") {
      return response?.data;
    } else {
      console.log("");
    }
  } catch (error) {
    console.error(error);
  }
};

// changing the api request with query so input detail will not empty
const getInventoryIds = async (id, classificationId, topId) => {
  let url = `${process.env.REACT_APP_API_HOST}/api/inventory?input=true&companyId=${id}&productClassification=${classificationId}&topId=${topId}`;
  try {
    const token = localStorage.getItem("cu_user");
    let response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.data.status === "success") {
      return response?.data;
    } else {
      console.log("");
    }
  } catch (error) {
    console.error(error);
  }
};

const getHeapInventories = async (id) => {
  let url = `${process.env.REACT_APP_API_HOST}/api/inventory?heapId=${id}`;
  try {
    const token = localStorage.getItem("cu_user");
    let response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.data.status === "success") {
      return response?.data;
    } else {
      console.log("");
    }
  } catch (error) {
    console.error(error);
  }
};

const getClassification = async () => {
  const url = `${process.env.REACT_APP_API_HOST}/api/product-classification`;
  try {
    const token = localStorage.getItem("cu_user");
    let response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.data.status === "success") {
      return response?.data;
    } else {
      console.log("");
    }
  } catch (error) {
    console.error(error);
  }
};

const getMetric = async (id) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/tc/countByUnit/${id}`;
  try {
    const token = localStorage.getItem("cu_user");
    let response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.data.status === "success") {
      return response?.data;
    } else {
      console.log("");
    }
  } catch (error) {
    console.error(error);
  }
};

const createUser = async (user) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/user`;
  const token = localStorage.getItem("cu_user");
  try {
    const response = await axios.post(url, user, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    return error;
  }
};

const addSupplier = async (body) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/external-supplier`;
  const token = localStorage.getItem("cu_user");
  try {
    const response = await axios.post(url, body, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    return error;
  }
};

const addSupplierProcurement = async (body) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/external-supplier`;
  const token = localStorage.getItem("cu_user");
  try {
    const response = await axios.post(url, body, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    return error;
  }
};

const reprintTC = async (id, body) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/tc/tc-reprint/${id}`;
  const token = localStorage.getItem("cu_user");
  try {
    const response = await axios.patch(url, body, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    return error;
  }
};

const reNewRC = async (body) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/cui-application-form/renew`;
  const token = localStorage.getItem("cu_user");
  try {
    const response = await axios.post(url, body, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    return error;
  }
};

const scopeExtension = async (body) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/cui-application-form/scope-extension`;
  const token = localStorage.getItem("cu_user");
  try {
    const response = await axios.post(url, body, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    return error;
  }
};

const rcExpiryStatus = async (id) => {
  const url = `${process.env.REACT_APP_API_HOST}/api/rc/${id}`;
  const token = localStorage.getItem("cu_user");
  try {
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

export {
  addFarmer,
  addFarm,
  getFarmers,
  getFarmer,
  applyForm,
  getProcess,
  getProgram,
  signIn,
  sendOTP,
  fogotPassword,
  resetPassword,
  getCommodity,
  getSingleProgram,
  checkResetPage,
  listRcs,
  addProcurementForm,
  getCompanyData,
  getProductInfo,
  getClassification,
  getInventory,
  getMetric,
  getCompanyUnit,
  applyTcForm,
  getAllBrokers,
  getOneSupplier,
  updateTcForm,
  getInventoryIds,
  getInventoryProc,
  getGeoCodes,
  getSuggestions,
  getUsers,
  getSellerUnits,
  createUser,
  updateFarm,
  deleteFarm,
  updateFarmer,
  deleteFarmer,
  addSupplier,
  getAllExternalSuppliers,
  getAllHeaps,
  updateProcurement,
  getProcByProcId,
  updateExternalSupplier,
  reprintTC,
  getHeapInventories,
  getOneInventoryDetails,
  reNewRC,
  scopeExtension,
  rcExpiryStatus,
};
